export default class MetaNavigation {
    constructor() {
        this._initScrollListener();
        this._attachCShopLinkEvent();
    }

    private _initScrollListener() {
        const toTop: HTMLElement | null = document.querySelector('#footer .to_top');

        document.addEventListener('scroll', () => {
            const lastKnownScrollPosition = window.scrollY;
            if (lastKnownScrollPosition > 102) {
                document.body.classList.add('scroll');
                toTop!.style.display = 'block';
            } else {
                document.body.classList.remove('scroll');
                toTop!.style.display = 'none';
            }
        });

        toTop!.addEventListener('click', () => {
            window.scrollTo({
                top: 0,
                behavior: 'smooth',
            });
        });
    }

    private _attachCShopLinkEvent(): void {
        const cShopLink: HTMLLinkElement | null = document.querySelector('#header .top .cshop > a');

        cShopLink?.addEventListener('click', () => {
            try {
                // @ts-ignore
                _paq.push(['trackEvent', 'Endkundenshop öffnen', 'Link in MetaNavigation']);
            } catch (e) {
                if (e instanceof ReferenceError) {
                    // Handle error as necessary
                }
            }
        });
    }
}
